<template>
  <div style="background: #ffffff; height: 100%;height:calc(100vh - 60px);overflow-y:hidden">
    <div style="background:url(../../static/images/404.webp) no-repeat;height:150px;width:250px;background-size:contain; margin:30vh auto 0;"></div>
    <div style="margin:20px;text-align:center;font-size:20px;color:#333333">
      页面正在假设中...
    </div>

  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'Index',
  data () {
    return {
     
    }
  },
  mounted: function () {
    var self = this

    let dealer = window.localStorage.getItem('customer')
    if (dealer) {
     
    } else {
      this.$message({
        message: '无登录信息，请重新登录',
        type: 'error'
      })
      self.$router.push({ name: 'Login' })
    }
  },
  computed: {

  },
  methods: {
    
  }
}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/components/404.vue